import HeaderMenu from "../../components/ui/HeaderMenu";
import Sidebar from "../../components/ui/Sidebar";
import { useAuthContext } from "../../context/auth";
import { useAuth } from "../../hooks/useAuth";
import ProtectedRoute from "../auth/ProtectedRoute";
import { cardStyle } from "../Places/PlacesTable";
import AdminHome from "./Home";
import PlaceAdminHome from "./PlaceAdminHome";

export default function Home() {
  const { user } = useAuthContext();
  const { isAdmin, isPlaceAdmin } = useAuth();

  return (
    <ProtectedRoute route="Auth">
      <HeaderMenu />
      <div className="d-flex">
        <Sidebar className="d-lg-block d-none" />
        <div className="w-100" style={{ backgroundColor: "#fafafa" }}>
          <div className="container-fluid py-4">
            {/* Welcome */}
            <div
              style={{ ...cardStyle, padding: "18px 22px" }}
              className="d-flex align-items-center gap-3 mb-4"
            >
              {user?.profilePicture ? (
                <img
                  src={user.profilePicture as string}
                  alt=""
                  width={56}
                  height={56}
                  className="flex-shrink-0"
                  style={{ borderRadius: 16, objectFit: "cover" }}
                />
              ) : (
                <span
                  className="d-inline-flex align-items-center justify-content-center flex-shrink-0 fw-bold"
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 16,
                    fontSize: 22,
                    color: "#f0813f",
                    backgroundColor: "rgba(240,129,63,0.14)",
                  }}
                >
                  {(user?.fullName?.[0] ?? "?").toUpperCase()}
                </span>
              )}
              <div style={{ minWidth: 0 }}>
                <h4 className="fs-4 fw-bold mb-0 text-capitalize">
                  Bonjour {user?.fullName} !
                </h4>
                <div className="text-muted" style={{ fontSize: 13 }}>
                  Bienvenue ! Gérez vos tâches et votre travail quotidien ici.
                </div>
              </div>
            </div>

            {isAdmin ? <AdminHome /> : isPlaceAdmin ? <PlaceAdminHome /> : null}
          </div>
        </div>
      </div>
    </ProtectedRoute>
  );
}
